import React, { Component } from 'react';
import styles from './footer.css';

var classNames = require('classnames');

class Footer extends Component {
  render() {
    return (
      <footer className={styles.row}>
        <div className={styles.logosContainer}>
          <div className={styles.logoGtx}><img src="" alt=""/></div>
          <div className={styles.logoBro}><img src="" alt=""/></div>
        </div>
        <ul className={classNames(styles.inline, styles.fooMenu)}>
          <li><a href="//brothergtx.com/de/vorteile-des-dtg.html" target="_blank" rel="noopener noreferrer">Vorteile des DTG</a></li>
          <li><a href="//brothergtx.com/de/technische-infos.html" target="_blank" rel="noopener noreferrer">Technische Infos</a></li>
          <li><a href="//brothergtx.com/de/multi-media-galerie.html" target="_blank" rel="noopener noreferrer">Multi-Media Galerie</a></li>
          <li><a href="//brothergtx.com/de/handler-in-der-nahe-finden.html" target="_blank" rel="noopener noreferrer">Händler in der Nähe finden</a></li>
        </ul>
        <p className={styles.footerP}>©1995-2018 Brother International Corporation. All rights reserved<br/> Images are for illustrative purposes only.</p>
        <ul className={classNames(styles.inline, styles.fooBro)}>
          <li><a href="//brothergtx.com/de/auxiliary/uber-brother.html" target="_blank" rel="noopener noreferrer">Über Brother</a></li>
          <li><a href="//brothergtx.com/de/auxiliary/privacy-policy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
          <li><a href="//brothergtx.com/de/auxiliary/kontakt.html" target="_blank" rel="noopener noreferrer">Kontakt</a></li>
          <li><a href="//brothergtx.com/de/auxiliary/impressum.html" target="_blank" rel="noopener noreferrer">Impressum</a></li>
        </ul>
      </footer>

    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/footer.js